export const AGENT_DASHBOARD_ROOT_PATH = "/agent";

export const AGENT_DASHBOARD_ROOT_PATTERN = `${AGENT_DASHBOARD_ROOT_PATH}/:projectId`;

export const AGENT_DASHBOARD_ROUTES = {
  default: AGENT_DASHBOARD_ROOT_PATH,
  root: AGENT_DASHBOARD_ROOT_PATTERN,
  home: `${AGENT_DASHBOARD_ROOT_PATTERN}/home`,
  chat: `${AGENT_DASHBOARD_ROOT_PATTERN}/chat`,
} as const;

export function getAgentDashboardPath({ projectId }: { projectId: string }) {
  return `${AGENT_DASHBOARD_ROOT_PATH}/${encodeURIComponent(projectId)}`;
}

/**
 * Deep link to a miniapp tab. `miniappRoute` is a route from
 * `schemas/miniappRoutes`' builders (already leading-slashed, `null` for the
 * miniapp's own home), and stays unencoded so its path segments survive.
 */
export function getAgentMiniappPath({
  projectId,
  miniappId,
  miniappRoute,
}: {
  projectId: string;
  miniappId: string;
  miniappRoute?: string | null;
}) {
  const miniappPath = `${getAgentDashboardPath({ projectId })}/miniapp/${encodeURIComponent(miniappId)}`;
  return miniappRoute ? `${miniappPath}${miniappRoute}` : miniappPath;
}

export function getAgentSessionDashboardUrl({
  dashboardBaseUrl,
  projectId,
  sessionId,
}: {
  dashboardBaseUrl: string;
  projectId: string;
  sessionId: string;
}) {
  const url = new URL(getAgentDashboardPath({ projectId }), dashboardBaseUrl);
  url.searchParams.set("sessionId", sessionId);
  return url.toString();
}

/**
 * Which of the two customer dashboards a project belongs in. `v1` is the
 * Shopify theme builder at /shops, `agent` is the agent dashboard at /agent,
 * and `v2` is a Replo-hosted project that has not been moved onto the agent
 * yet (it lives at /shops/:projectId/home).
 */
export type DashboardSurface = "v1" | "v2" | "agent";

export function getDashboardSurface({
  hostingType,
  agentEnabledAt,
}: {
  hostingType: string | null;
  agentEnabledAt: Date | string | null;
}): DashboardSurface {
  if (hostingType !== "replo") {
    return "v1";
  }
  return agentEnabledAt ? "agent" : "v2";
}
